import type { Tag } from './tags';

type Response = Record<string, unknown>;

function getId<R extends Response>(entry: R, key: keyof R) {
  const id = entry[key];
  if (typeof id !== 'string') {
    throw new Error('Unknown ID');
  }
  return id;
}

export function provider<R extends Response>(tag: Tag, key: keyof R | null = 'id') {
  return function (result: R | Array<R> | void) {
    if (key === null) {
      return [tag];
    }

    if (Array.isArray(result)) {
      return result.map((entry) => {
        return { type: tag, id: getId(entry, key) };
      });
    }

    if (result) {
      return [{ type: tag, id: getId(result, key) }];
    }

    return [tag];
  };
}
